import Link from 'next/link'

import CustumeModal from '@/components/custome-modal'
import SuccessIcon from '@/screens/dashboard/ui/SuccessIcon'
import ErrorIcon from '../ErrorIcon'


export function PaymentResponseModal({
  isOpen,
  onClose,
  isSuccess = true,
}: {
  isOpen: boolean
  onClose: () => void
  isSuccess?: boolean
}) {
  return (
    <CustumeModal isOpen={isOpen} onClose={onClose}>
      <div className='flex flex-col gap-10 items-center my-10'>
        {isSuccess ? <SuccessIcon /> : <ErrorIcon />}
        <div className=' text-center'>
          <p className='font-semibold text-xl md:text-4xl'>
            Payment {isSuccess ? 'successful' : 'unsuccessful'}!
          </p>
          <p className='mt-2 md:mt-4 text-[#7A7A7A] text-sm md:text-base'>
            {isSuccess
              ? 'Your payment has been successfully submitted!'
              : 'Please try again as your payment was unsuccessful'}
          </p>
          <Link href={'/'} className='mt-3 text-blue-600 underline '>
            Go to homepage
          </Link>
        </div>
      </div>
    </CustumeModal>
  )
}
